import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import actionJson from './communityGardenDocumentList.action.json' with { type: 'json' }
import { communityGardenDocumentObject } from '../communityGardenDocumentObject'

export const communityGardenDocumentExpression = expression(communityGardenDocumentObject.shape)

const communityGardenDocumentListDefinition = defineAction({
  ...actionJson,

  input: z.object({
    filter: communityGardenDocumentExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      fileName: 'Nome do arquivo',
      id: 'Identificador',
      status: 'Status',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),

  output: z.object({ items: z.array(communityGardenDocumentObject), count: z.number() }),
})

export default communityGardenDocumentListDefinition
